export default __webpack_public_path__ + "img/img_ahikaa-5ce5e955f8301bb42a13e524d7a7f1fc.png";